import {isNil} from 'ramda';

import type {ImageAssetRef} from '@dms/api/new-vehicle';

import type {Nullish} from 'shared/web';

/** Whether a list shows any image, so each of its rows reserves the thumbnail's slot. */
export const hasAnyImage = (rows: {imageAssetRef?: ImageAssetRef | Nullish}[]) =>
  rows.some(({imageAssetRef}) => !isNil(imageAssetRef));
